import DPO from 'dpo8core';

export const getWhiteTreatmentHint = (hints = []) => hints.find(hint => hint.name === 'whiteTreatment');

export const getOriginalNameFromHint = (hints = []) => hints.find(hint => hint.name === 'original');

export const parseWhiteTreatmentHint = (hint = { value: '' }) => {
  const [whiteTreatment, tolerance] = hint.value.split('-');

  return { whiteTreatment: whiteTreatment || null, tolerance: tolerance || null };
}

export const getProjectHintValue = ({ project: { hints } }, hint) => hints.find(({ name }) => name === hint)?.value;
export const getProductHintValue = ({ product: { hints = [] } = {} }, hint) => hints.find(({ name }) => name === hint)?.value;

export const addProjectHint = ({ project: { hints } }, hintName, hintValue) => {
  const hint = hints.find(({ name }) => name === hintName);
  if (hint) {
    hint.value = hintValue;
    return;
  }
  const newHint = new DPO.model.Hint();
  newHint.name = hintName;
  newHint.value = hintValue;
  hints.push(newHint);
};

export const getProjectShape = ({ projectEditor: { pt } }) => getProjectHintValue(pt, 'projectShape') || 'polygon';

export const getProjectContourCutOption = ({ projectEditor: { pt } }) => getProjectHintValue(pt, 'contourCut') || false;

export const setProjectContourCutOption = ({ projectEditor: { pt } }, value) => addProjectHint(pt, 'contourCut', value);

export const getArtworkOriginalSizes = ({ projectEditor: { pt } }) => JSON.parse(getProjectHintValue(pt, 'artworkOriginalSizes') || 'false');

export const setArtworkOriginalSizes = ({ projectEditor: { pt } }, { highResolution: { width, height } }) => addProjectHint(pt, 'artworkOriginalSizes', JSON.stringify({ width, height }));

export const getWhiteSpotColorDetected = ({ projectEditor: { pt } }) => JSON.parse(getProjectHintValue(pt, 'whiteSpotColorDetected') || 'false');

export const getNonCustomShapeName = ({ projectData }) => getProductHintValue(projectData, 'NonCustomShape');

export const isCreatedFromDielineShape = ({ project }) => !!project && getProjectHintValue({ project }, 'projectState') === 'createdFromCustomShape';